/** A solo year that could not run comes back to Decide with the draft intact; this says why, in the engine-side words, and the way back (ADR-0050). */
import { useRoute } from "../api/context";
import { GxNotice } from "../theme/primitives";

export function ResolveFailure({ runId }: { readonly runId: string }) {
  const run = useRoute("soloResume", { runId });
  const failure = run.data?.resolveFailure;
  if (failure === undefined) return null;
  return (
    <div style={{ marginBottom: 12 }} data-testid="decide.resolvefailure">
      <GxNotice><b>The year could not run.</b> {failure.message} Your choices are saved below.</GxNotice>
    </div>
  );
}
